import { actionTypes } from 'BASE/store/types'
import SETTING from 'BASE/common/chat/chat.setting'

export default {
    props: {
        dialog: Object,
    },
    data: function () {
        return {
            inputMessage: "",
            errorMessage: "",
        }
    },
    methods: {
        confirm: async function (){
            let loader;
            if (SETTING.ENABLE_CHECK_CONNECTION_BEFORE_ACTION) {
                loader = this.$loading.show();
            }

            this.errorMessage = await this.$store.dispatch(actionTypes.CHAT_ADD_GROUP_ROOM, { 
                roomName: this.inputMessage,
                connectionParams: {
                    waitConnected: true,
                },
            });
            
            if (SETTING.ENABLE_CHECK_CONNECTION_BEFORE_ACTION) {
                loader.hide();
            }
            
            if (!this.errorMessage) {
                this.cancel();
            }
        },
        cancel: function () {
            this.inputMessage = "";
            this.errorMessage = "";
            this.dialog.$emit('close');
        },
    },
};